var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoConfigureTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72732e-06 0.609375C5.72732e-06 0.272826 0.279653 0 0.624615 0H6.87071C7.21567 0 7.49532 0.272826 7.49532 0.609375V7.0407L12.676 2.00578C12.92 1.76858 13.3149 1.76895 13.5584 2.00661L17.9751 6.31555C18.0924 6.42998 18.1582 6.58521 18.158 6.74703C18.1579 6.90885 18.0917 7.06396 17.9742 7.17817L12.8199 12.1875H19.3629C19.7079 12.1875 19.9875 12.4603 19.9875 12.7969V18.8906C19.9875 19.2272 19.7079 19.5 19.3629 19.5H3.74766C2.71277 19.5 1.77586 19.0908 1.09766 18.4291C0.736688 18.0769 0.464745 17.6708 0.281834 17.2373C0.262791 17.1923 0.244644 17.1468 0.227412 17.1009C0.0862869 16.7249 0.0066567 16.3199 0.000404373 15.8976M7.49532 15.642L16.6492 6.74562L13.1159 3.29846L7.49532 8.76097V15.642ZM5.62149 15.8438C5.62149 14.8341 4.78255 14.0156 3.74766 14.0156C2.71277 14.0156 1.87383 14.8341 1.87383 15.8438C1.87383 16.8534 2.71277 17.6719 3.74766 17.6719C4.78255 17.6719 5.62149 16.8534 5.62149 15.8438ZM18.7383 18.2812V13.4062H11.5659L6.54979 18.2812H18.7383Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72732e-06 0.609375V15.8373V0.609375Z",
    fill: "#1C2743"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72732e-06 15.8373V15.8438C5.72732e-06 15.8617 0.000139432 15.8797 0.000404373 15.8976C0.000103173 15.8775 -3.02293e-05 15.8574 5.72732e-06 15.8373Z",
    fill: "#1C2743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConfigureTemplate);
export default __webpack_public_path__ + "static/media/ico-configure-template.1cccb15f9631d59884f3b57a47870ad2.svg";
export { ForwardRef as ReactComponent };